import { Box, Button, HStack, Image, Text, VStack } from "@chakra-ui/react";
import React from "react";
import useScreenWidth from "../../lib/useGetScreenWidth";
import { Link } from "react-router-dom";
import NavDrawer from "./NavDrawer";
import HeroBanner from "../feedback/HeroBanner";
import AuthComponent from "./AuthComponent";

export default function Nav() {
  const sw = useScreenWidth();

  return (
    <VStack w={"100%"} gap={0} position={"sticky"} top={0} zIndex={99} id="nav">
      <HeroBanner />

      <Box
        w={"100%"}
        bg={"whiteAlpha.900"}
        backdropFilter={"blur(5px)"}
        borderBottom={"1px solid var(--divider3)"}
      >
        <HStack
          w={"100%"}
          maxW={"1440px"}
          p={4}
          gap={4}
          justify={"space-between"}
          mx={"auto"}
        >
          <HStack
            gap={1}
            flexShrink={0}
            w={sw >= 850 ? "219.86px" : ""}
            as={Link}
            to={"/"}
          >
            <Image src="/images/logo.png" h={"40px"} mr={1} />
            {sw > 500 && (
              <Box color={"p.500"}>
                <Text fontWeight={800} lineHeight={1.2}>
                  KUBU
                </Text>
                <Text fontWeight={800} lineHeight={1.2}>
                  COURSE
                </Text>
              </Box>
            )}
          </HStack>

          {sw >= 850 ? (
            <>
              <HStack>
                <Button
                  as={Link}
                  to={"https://kubu.id"}
                  colorScheme="ap"
                  variant={"ghost"}
                >
                  Kubu.id
                </Button>

                <Button as={Link} to={"/"} colorScheme="ap" variant={"ghost"}>
                  Beranda
                </Button>

                <Button
                  as={Link}
                  to={"/allcourses"}
                  colorScheme="ap"
                  variant={"ghost"}
                >
                  Semua Course
                </Button>
              </HStack>

              <AuthComponent />
            </>
          ) : (
            <HStack>
              <AuthComponent />

              <NavDrawer />
            </HStack>
          )}
        </HStack>
      </Box>
    </VStack>
  );
}
